import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  campaignData: null,
  status: 'idle',
  error: null,
};

const dataSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setCampaignData: (state, action) => {
      state.campaignData = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setCampaignData, setError, setLoading } = dataSlice.actions;
export default dataSlice.reducer;
